var map = {
	"./annex-ar/annex1.png": 596,
	"./annex-ar/annex2.png": 597,
	"./annex-ar/annex3.png": 598,
	"./annex-ar/annex4.png": 599,
	"./annex-ar/annex5.png": 600,
	"./annex-ar/annex6.png": 601,
	"./annex-ar/annexTable1.png": 602,
	"./annex-ar/annexTable10.png": 603,
	"./annex-ar/annexTable11.png": 604,
	"./annex-ar/annexTable12.png": 605,
	"./annex-ar/annexTable13.png": 606,
	"./annex-ar/annexTable14.png": 607,
	"./annex-ar/annexTable15.png": 608,
	"./annex-ar/annexTable16.png": 609,
	"./annex-ar/annexTable17.png": 610,
	"./annex-ar/annexTable18.png": 611,
	"./annex-ar/annexTable19.png": 612,
	"./annex-ar/annexTable2.png": 613,
	"./annex-ar/annexTable20.png": 614,
	"./annex-ar/annexTable21.png": 615,
	"./annex-ar/annexTable22.png": 616,
	"./annex-ar/annexTable23.png": 617,
	"./annex-ar/annexTable3.png": 618,
	"./annex-ar/annexTable4.png": 619,
	"./annex-ar/annexTable5.png": 620,
	"./annex-ar/annexTable6.png": 621,
	"./annex-ar/annexTable7.png": 622,
	"./annex-ar/annexTable8.png": 623,
	"./annex-ar/annexTable9.png": 624,
	"./annex/annex1.png": 625,
	"./annex/annex2.png": 626,
	"./annex/annex3.png": 627,
	"./annex/annex4.png": 628,
	"./annex/annex5.png": 629,
	"./annex/annex6.png": 630,
	"./annex1.png": 283,
	"./annex10.png": 284,
	"./annex11.png": 285,
	"./annex12.png": 286,
	"./annex13.png": 287,
	"./annex14.png": 288,
	"./annex2.png": 289,
	"./annex3.png": 290,
	"./annex4.png": 291,
	"./annex5.png": 292,
	"./annex6.png": 293,
	"./annex7.png": 294,
	"./annex8.png": 295,
	"./annex9.png": 296,
	"./copyright.png": 297,
	"./cover-light.png": 631,
	"./f0014-01.png": 280,
	"./f0014-02.png": 281,
	"./f0015-01.png": 282,
	"./favicon-16x16.png": 632,
	"./favicon-16x16_01.png": 633,
	"./favicon-32x32.png": 634,
	"./favicon-32x32_01.png": 635,
	"./fig25.png": 298,
	"./fig56.png": 299,
	"./fig57.png": 300,
	"./imac-mockup-01.png": 636,
	"./next.png": 637,
	"./poster-sdg-1.png": 278,
	"./poster-sdg-10.png": 301,
	"./poster-sdg-12.png": 302,
	"./poster-sdg-14.png": 303,
	"./poster-sdg-15.png": 304,
	"./poster-sdg-2.png": 279,
	"./poster-sdg-5.png": 305,
	"./poster-sdg-6.png": 306,
	"./prev.png": 638,
	"./reportCover.png": 639,
	"./sdg-12-load.png": 640,
	"./sdg-14-load.png": 641,
	"./sdg-15-load.png": 642,
	"./sdg-2-load.png": 643,
	"./sdg-5-load.png": 644,
	"./sdg-6-load.png": 645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;